import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMarkerPin01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 10a9 9 0 0 1 18 0c0 2.526-1.147 4.74-2.708 6.767-1.304 1.694-2.974 3.349-4.641 5.002l-.002.001c-.314.313-.63.625-.942.937a1 1 0 0 1-1.414 0c-.313-.313-.629-.626-.944-.938-1.668-1.653-3.337-3.308-4.641-5.002C4.147 14.74 3 12.527 3 10Zm12 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgMarkerPin01.displayName = 'MarkerPin01';
export default SvgMarkerPin01;
